import { motion } from 'framer-motion';
import { FaChevronLeft, FaChevronRight, FaPlay, FaPause } from 'react-icons/fa';

const CarouselControls = ({ 
  onPrevious, 
  onNext, 
  isPlaying, 
  onTogglePlay,
  showPlayPause = true,
}) => {
  return (
    <>
      {/* Previous Button */}
      <motion.button
        whileHover={{ scale: 1.1 }}
        whileTap={{ scale: 0.9 }}
        onClick={onPrevious}
        className="absolute left-4 top-1/2 transform -translate-y-1/2 z-10 p-4 bg-white/20 hover:bg-white/40 backdrop-blur-sm rounded-full text-white shadow-lg transition-all"
        aria-label="Previous slide"
      >
        <FaChevronLeft className="text-2xl" />
      </motion.button>

      {/* Next Button */}
      <motion.button
        whileHover={{ scale: 1.1 }}
        whileTap={{ scale: 0.9 }}
        onClick={onNext}
        className="absolute right-4 top-1/2 transform -translate-y-1/2 z-10 p-4 bg-white/20 hover:bg-white/40 backdrop-blur-sm rounded-full text-white shadow-lg transition-all"
        aria-label="Next slide"
      >
        <FaChevronRight className="text-2xl" />
      </motion.button>

      {/* Play/Pause Button */}
      {showPlayPause && (
        <motion.button
          whileHover={{ scale: 1.1 }}
          whileTap={{ scale: 0.9 }}
          onClick={onTogglePlay}
          className="absolute top-4 left-4 z-10 p-3 bg-white/20 hover:bg-white/40 backdrop-blur-sm rounded-full text-white shadow-lg transition-all"
          aria-label={isPlaying ? 'Pause slideshow' : 'Play slideshow'}
        >
          {isPlaying ? (
            <FaPause className="text-lg" />
          ) : (
            <FaPlay className="text-lg ml-0.5" />
          )}
        </motion.button>
      )}
    </>
  );
};

export default CarouselControls;